import {getEq, Left, left, Right, right} from 'fp-ts/lib/Either';
import {Eq} from 'fp-ts/lib/Eq';
import {getAsyncEq, Loaded} from './Async';
import {Validatable} from './Validatable';
import {StringUnion, NonEmptyString, eqStringUnion, EmptyString} from './EmptyString';

export type ValidatableNonEmptyString = Validatable<StringUnion, NonEmptyString>;

export const eqValidatableNonEmptyString: Eq<ValidatableNonEmptyString> = getAsyncEq(
  getEq(eqStringUnion, eqStringUnion)
);
export type ValidatedNonEmptyString = Loaded<Right<NonEmptyString>>;

export const createValidatedNonEmptyString = (value: string): Loaded<Right<NonEmptyString>> =>
  new Loaded(right(NonEmptyString.create(value) as NonEmptyString)) as Loaded<Right<NonEmptyString>>;

export const createValidatableEmptyString = (): Loaded<Left<EmptyString>> =>
  new Loaded(left(new EmptyString())) as Loaded<Left<EmptyString>>;
